import styled from 'styled-components/native';
import {
  ColorProps,
  FontFamilyProps,
  FontSizeProps,
  FontWeightProps,
  SpaceProps,
  color,
  fontFamily,
  fontSize,
  fontWeight,
  space,
} from 'styled-system';

export interface StyledTextInputProps
  extends ColorProps,
    FontFamilyProps,
    FontSizeProps,
    SpaceProps,
    FontWeightProps {}

export const StyledTextInput = styled.TextInput<StyledTextInputProps>`
  ${color};
  ${fontFamily};
  ${fontSize};
  ${fontWeight};
  ${space};
`;
